<template>
  <div>
    <div class="g-main-header top-offset">
      <!-- Slider main container -->
      <swiper :options="swiperOption">
        <swiper-slide>
          <div class="g-slider-wrapper">
            <img src="../../assets/images/slider/slide-1-min.png" alt="">
          </div>
        </swiper-slide>
        <!--<swiper-slide>-->
          <!--<div class="g-slider-wrapper">-->
            <!--<img src="../../assets/images/Banner2.png" alt="">-->
          <!--</div>-->
        <!--</swiper-slide>-->
        <!--<swiper-slide>-->
          <!--<div class="g-slider-wrapper">-->
            <!--<img src="../../assets/images/slideimage.png" alt="">-->
          <!--</div>-->
        <!--</swiper-slide>-->
        <!--<swiper-slide>-->
          <!--<div class="g-slider-wrapper">-->
            <!--<img src="../../assets/images/slideimage.png" alt="">-->
          <!--</div>-->
        <!--</swiper-slide>-->
      </swiper>
      <v-container grid-list-xl>
      <div class="g-main-header-content">
          <v-layout row>
            <v-flex lg6>
              <div class="g-slider-title g-bold mb-3"><h1>{{ $t('better_to_give') }}</h1></div>
              <p class="g-slider-p"> </p>
              <v-form class="mb-3 d-flex" v-if="!loggedUser.id && showModalButtons">
                <v-btn class="g-btn-main-light g-middle-btn g-up-letter ml-0" @click="openRegModal">{{ $t('sign_up') }}</v-btn>
              </v-form>
            </v-flex>
          </v-layout>
      </div>
      </v-container>
    </div>
    <features-section
      :loggedUser = "loggedUser"
      :showModalButtons = "showModalButtons"
      @openLogModal ="openLogModal"
      @openRegModal ="openRegModal"
      :key="updateComponentByLanguage"
    >
    </features-section>
    <about
            :loggedUser = "loggedUser"
            :showModalButtons = "showModalButtons"
            :showRegistrationModal = "showRegistrationModal"
            :showLoginModal = "showLoginModal"
            :settings = "settings"
            @openRegModal ="openRegModal"
            @openLogModal ="openLogModal"
    >
    </about>
  </div>
</template>
<script>
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Features from '../welcomePage/Features'
import About from '../welcomePage/About.vue'
import GetInTouch from '../welcomePage/GetInTouch.vue'
import { mapState } from 'vuex'
Vue.use(VueAwesomeSwiper)
export default {
  name: 'mainPage',
  props: ['showRegistrationModal', 'showLoginModal', 'settings', 'loggedUser', 'showModalButtons'],
  components: {
    About,
    'get-in-touch': GetInTouch,
    'features-section': Features
  },
  data () {
    return {
      updateComponentByLanguage: false,
      swiperOption: {
        direction: 'vertical',
        autoplay: true,
        delay: 7000,
        effect: 'fade',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  watch: {
    'activeLanguage': {
      handler () {
        this.updateComponentByLanguage = !this.updateComponentByLanguage
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      activeLanguage: state => state.common.activeLanguage
    })
  },
  methods: {
    openRegModal () {
      this.$emit('openRegModal')
    },
    openLogModal () {
      this.$emit('openLogModal')
    },
    getLanguageName (name) {
      let value = ''
      if (this.settings.length > 0) {
        this.settings.forEach(setting => {
          if (setting.name === name) {
            value = setting.value
          }
        })
      }
      return value
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "../../assets/sass/desktop/mainPage.scss";
  @import "../../assets/sass/desktop/customSlider.scss";
</style>



// WEBPACK FOOTER //
// src/components/welcomePage/mainPage.vue